import { MODULES } from './modules';

export const MODULES_META: Record<string, { name: string; description: string; features: string[] }> = {
  [MODULES.POLICY_ADMIN]: {
    name: 'Policy Administration',
    description: 'Manage the full policy lifecycle from intake to renewal.',
    features: [
      'Policy issuance and endorsements',
      'Automated renewal management',
      'Premium calculations',
      'Product builder',
    ],
  },
  [MODULES.CLAIMS]: {
    name: 'Claims Management',
    description: 'Process and track claims from FNOL through settlement.',
    features: [
      'First Notice of Loss (FNOL) intake',
      'Claims adjudication workflow',
      'Recourse and litigation tracking',
      'Automated STP claims',
    ],
  },
  [MODULES.CLIENT_AGENT]: {
    name: 'Clients & Agents',
    description: 'Manage your client portfolio and distribution network.',
    features: [
      'Client KYC and onboarding',
      'Agent management and commissions',
      'Client portal access',
      'Document storage',
    ],
  },
  [MODULES.BILLING_FINANCE]: {
    name: 'Billing & Finance',
    description: 'Full financial operations for your insurance company.',
    features: [
      'Premium collection and receipting',
      'Commission disbursements',
      'Reinsurance accounting',
      'Tax reporting',
    ],
  },
  [MODULES.ANALYTICS]: {
    name: 'Analytics',
    description: 'Data-driven insights across your entire operation.',
    features: [
      'Underwriting analytics',
      'Claims analytics',
      'Financial performance reports',
      'Agent performance tracking',
    ],
  },
  [MODULES.AI_COPILOT]: {
    name: 'AI Insurance Intelligence',
    description: 'AI-powered intelligence for insurance operations.',
    features: [
      'Policy document analysis',
      'Claims assessment assistance',
      'Smart data extraction',
      'Regulatory compliance checks',
    ],
  },
  [MODULES.STP]: {
    name: 'STP Engine',
    description: 'Straight-through processing for automated insurance workflows.',
    features: [
      'Automated policy issuance rules',
      'Claims auto-adjudication',
      'Risk scoring engine',
      'STP performance analytics',
    ],
  },
  [MODULES.HR]: {
    name: 'HR & Staff',
    description: 'Human resources management for your insurance team.',
    features: [
      'Employee records management',
      'Leave management',
      'Payroll integration',
      'Organisational structure',
    ],
  },
  [MODULES.INTEGRATION]: {
    name: 'Integrations',
    description: 'Connect Fast Policy with your existing systems.',
    features: [
      'REST API access',
      'Webhook configuration',
      'Third-party integrations',
      'Custom data pipelines',
    ],
  },
};
